import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { FilterActions } from '../constants/filter/filter_actions';

class CatalogMobileFilterVisibilityClass extends ReduceStore {
    getInitialState() {
        return {
            isVisible: false
        };
    }

    reduce(state, {source, action}) {
        if (source === ACTION_TYPES.CATALOG_MOBILE_FILTER_VISIBILITY_ACTION) {
            switch (action.type) {
                case FilterActions.SHOW_MOBILE_FILTERS:
                    if (!state.isVisible) {
                        state.isVisible = true;
                        this.__emitChange();
                    }

                    break;
                case FilterActions.HIDE_MOBILE_FILTERS:
                    if (state.isVisible) {
                        state.isVisible = false;
                        this.__emitChange();
                    }

                    break;
            }
        }

        return state;
    }
}

const CatalogMobileFilterVisibility = new CatalogMobileFilterVisibilityClass(Dispatcher);
export default CatalogMobileFilterVisibility;